/* ALBEUX RATING COUNT (2 Nov 2026, Copy of Futuristic).
   Wherever a rating number is shown (the rating panel above the footer, the Customer Reviews score on the product page), it runs like a stopwatch:
   it starts at 0.0, ticks up fast in tenths, slows down, and stops on the real number (4.9, say) the first time a customer sees it.
   The stars next to the product page score fill in step with it, and the five lines under the panel's number open as before (assets/albeux-trust.css).
   An element opts in with data-alb-count="4.9" (the real number). Nothing runs for people who ask for reduced motion, or without IntersectionObserver:
   they just see the number.
   To switch it off: delete the albeux-rating-count line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albRC) return;
  window.__albRC = true;
  try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

  var DUR = 2100;
  var io = new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      if (!es[i].isIntersecting) continue;
      var t = es[i].target;
      io.unobserve(t);
      if (t.__rcEl) run(t.__rcEl, t);
    }
  }, { threshold: 0.4 });

  function run(el, box) {
    if (!el.isConnected) return;
    var end = parseFloat(el.getAttribute('data-alb-count'));
    var final = el.getAttribute('data-alb-count');
    if (box && box.hasAttribute('data-albeux-trust')) box.classList.add('is-in');
    var t0 = null;
    (function tick(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / DUR);
      var v = end * (1 - Math.pow(1 - p, 3.4));
      if (p < 1) {
        el.textContent = v.toFixed(1);
        if (el.__rcStars) el.__rcStars.style.setProperty('--r', String(Math.round(v * 100) / 100));
        requestAnimationFrame(tick);
      } else {
        el.textContent = final;
        if (el.__rcStars) el.__rcStars.style.setProperty('--r', String(end));
      }
    })(performance.now());
  }

  function init() {
    try {
      var els = document.querySelectorAll('[data-alb-count]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.__rc) continue;
        var end = parseFloat(el.getAttribute('data-alb-count'));
        if (!(end > 0)) continue;
        el.__rc = true;
        var box = el.closest('[data-albeux-trust]');
        var sum = el.closest('[data-albeux-summary]');
        var stars = sum && sum.querySelector('.albeux-stars');
        var target = box || el;
        target.__rcEl = el;
        if (stars) { el.__rcStars = stars; stars.style.setProperty('--r', '0'); }
        if (box) box.classList.add('is-ready');
        el.textContent = '0.0';
        io.observe(target);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 200); });
  /* pages that slid in are not part of the first load: look again while the customer scrolls */
  var wait = false;
  window.addEventListener('scroll', function () {
    if (wait) return;
    wait = true;
    setTimeout(function () { wait = false; init(); }, 400);
  }, { passive: true });
  setTimeout(init, 1500);
})();
